import React, { useCallback } from 'react';
import { Box, Thumbnail, Text } from '@wix/design-system';
export const PredefinedQuestions = _ref => {
  let {
    data: {
      questions
    },
    context: {
      send
    }
  } = _ref;
  const onQuestionClick = useCallback(question => () => send(question), [send]);
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2"
  }, questions == null ? void 0 : questions.map(question => /*#__PURE__*/React.createElement(Thumbnail, {
    onClick: onQuestionClick(question)
  }, /*#__PURE__*/React.createElement(Box, {
    padding: "SP2 SP3"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "normal",
    skin: "primary"
  }, question)))));
};

/*
<<{
      "text": "Sure, just type a question below, or click one of these:",
      "widget": "PREDEFINED_QUESTIONS",
      "data": {
          "questions": [
            "What words or phrases do people use to find my site on Google?",
            "Which page do visitors spend the most time on?",
            "How much time do people spend on my website?"
          ]
      }
  }>>
*/
//# sourceMappingURL=PredefinedQuestions.js.map